webpackJsonp([13],{

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(827)
}
var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-298ae146",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(737), __esModule: true };

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(367);
__webpack_require__(739);
module.exports = __webpack_require__(27).Array.from;


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(75);
var createDesc = __webpack_require__(152);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(74);
var $export = __webpack_require__(56);
var toObject = __webpack_require__(150);
var call = __webpack_require__(371);
var isArrayIter = __webpack_require__(370);
var toLength = __webpack_require__(151);
var createProperty = __webpack_require__(738);
var getIterFn = __webpack_require__(369);

$export($export.S + $export.F * !__webpack_require__(372)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(149);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_handy__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_handy__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      beingSaved: false,
      config: __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a,
      handy: __WEBPACK_IMPORTED_MODULE_3__utils_handy___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_3__utils_handy___default.a.rules,
      showCompliance: false,
      lCompliance: {
        action: 'Create',
        compliance_id: null,
        name: '',
        compliance_type_id: null,
        compliance_category_id: null,
        compliance_subcategory_id: null,
        remarks: '',
        frequency: '',
        valid_from: '',
        valid_to: '',
        show_dashboard: false,
        notify_before_days: 0,
        files: []
      },
      validFromMenu: false,
      validToMenu: false,
      complianceTypeList: [],
      complianceCategoryList: [],
      complianceSubcatList: []
    };
  },

  computed: {
    filteredComplianceSubcategories: function filteredComplianceSubcategories() {
      var _this = this;

      if (!this.lCompliance.compliance_category_id) {
        return [];
      }
      return this.complianceSubcatList.filter(function (sub) {
        return sub.category_id === _this.lCompliance.compliance_category_id;
      });
    }
  },
  mounted: function mounted() {
    this.loadComplianceType();
    this.loadComplianceCategory();

    // Check if we need to open dialog with a specific compliance ID from route params
    if (this.$route.params.id) {
      this.loadComplianceById(this.$route.params.id);
    }
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    loadComplianceType: function loadComplianceType() {
      var _this2 = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + '/getComplianceType?comm_id=' + __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.COMM_ID).then(function (response) {
        // Normalize the response to ensure consistent field naming
        _this2.complianceTypeList = response.data.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
            compliance_type_id: item.id || item.compliance_type_id,
            id: item.id || item.compliance_type_id
          });
        });
      }).catch(function () {
        _this2.msg('Error loading compliance types', 0);
      });
    },
    loadComplianceCategory: function loadComplianceCategory() {
      var _this3 = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + '/getComplianceCategory?comm_id=' + __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.COMM_ID).then(function (response) {
        _this3.complianceCategoryList = response.data;
        // Load subcategories after categories are loaded
        _this3.loadComplianceSubcategory();
      }).catch(function () {
        _this3.msg('Error loading compliance categories', 0);
      });
    },
    loadComplianceSubcategory: function loadComplianceSubcategory() {
      var _this4 = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + '/getComplianceSubcategory?comm_id=' + __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.COMM_ID).then(function (response) {
        _this4.complianceSubcatList = response.data;
      }).catch(function () {
        _this4.msg('Error loading compliance subcategories', 0);
      });
    },
    loadComplianceById: function loadComplianceById(complianceId) {
      var _this5 = this;

      // Load compliance data and open dialog for editing
      this.axios.get(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + '/getCompliance?id=' + complianceId).then(function (response) {
        if (response.data && response.data.length > 0) {
          _this5.prepareEditCompliance(response.data[0]);
        }
      }).catch(function () {
        _this5.msg('Error loading compliance record', 0);
      });
    },
    loadComplianceAttachment: function loadComplianceAttachment(complianceId) {
      var _this6 = this;

      var path = __webpack_require__(368);
      var qry = {
        params: {
          compliance_id: complianceId
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + '/getComplianceAttachments/', qry).then(function (response) {
        _this6.lCompliance.files = [];
        response.data.forEach(function (rec) {
          _this6.lCompliance.files.push({
            file_url: rec.file_url,
            file_name: path.basename(rec.file_url),
            is_selected: true,
            is_changed: false
          });
        });
      }).catch(function (err) {
        console.error('Error loading attachments:', err);
        _this6.lCompliance.files = [];
      });
    },
    prepareEditCompliance: function prepareEditCompliance(item) {
      var formatDateForPicker = function formatDateForPicker(isoStr) {
        if (!isoStr) return '';
        var d = new Date(isoStr);
        var month = (d.getMonth() + 1).toString().padStart(2, '0');
        var day = d.getDate().toString().padStart(2, '0');
        return d.getFullYear() + '-' + month + '-' + day;
      };

      // Ensure compliance_type_id is properly set
      var typeId = item.compliance_type_id || item.type_id;

      this.lCompliance = {
        action: 'Update',
        id: item.id,
        name: item.compliance_name || item.name,
        compliance_type_id: typeId,
        compliance_category_id: item.category_id || item.compliance_category_id,
        compliance_subcategory_id: item.subcategory_id || item.compliance_subcategory_id,
        remarks: item.remarks || '',
        frequency: item.frequency || '',
        valid_from: formatDateForPicker(item.valid_from),
        valid_to: formatDateForPicker(item.valid_to),
        show_dashboard: item.show_dashboard || false,
        notify_before_days: item.notify_before_days || 0,
        files: []

        // Load attachments for this compliance
      };if (item.id) {
        this.loadComplianceAttachment(item.id);
      }

      this.showCompliance = true;
    },
    onComplianceCategoryChange: function onComplianceCategoryChange() {
      // Reset subcategory when category changes
      this.lCompliance.compliance_subcategory_id = null;
    },
    pickFile: function pickFile() {
      this.$refs.fileInput.click();
    },
    loadFilesFromFileBrowser: function loadFilesFromFileBrowser() {
      var _this7 = this;

      var files = event.target.files;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(files).forEach(function (file) {
        var fileReader = new FileReader();
        fileReader.onload = function (e) {
          _this7.lCompliance.files.push({
            file_url: e.target.result.split(',')[1],
            file_name: file.name,
            is_selected: true,
            is_changed: true
          });
          _this7.$forceUpdate();
        };
        fileReader.readAsDataURL(file);
      });
      // Reset the input
      this.$refs.fileInput.value = '';
    },
    closeDialog: function closeDialog() {
      this.showCompliance = false;
      // Optionally navigate back or emit event
      if (this.$route.params.id) {
        this.$router.go(-1);
      }
    },
    saveCompliance: function saveCompliance(action) {
      var _this8 = this;

      if (!this.$refs.complianceForm.validate()) {
        return;
      }

      // Additional validation
      if (!this.lCompliance.name || this.lCompliance.name.trim() === '') {
        this.msg('Please enter compliance name', 0);
        return;
      }

      // Critical validation for compliance_type_id
      if (!this.lCompliance.compliance_type_id || this.lCompliance.compliance_type_id === null) {
        console.error('Compliance Type ID is null or undefined:', this.lCompliance.compliance_type_id);
        this.msg('Please select compliance type', 0);
        return;
      }

      if (!this.lCompliance.compliance_category_id) {
        this.msg('Please select compliance category', 0);
        return;
      }
      if (!this.lCompliance.compliance_subcategory_id) {
        this.msg('Please select compliance subcategory', 0);
        return;
      }
      if (!this.lCompliance.frequency) {
        this.msg('Please select frequency', 0);
        return;
      }
      if (!this.lCompliance.valid_from) {
        this.msg('Please select valid from date', 0);
        return;
      }
      if (!this.lCompliance.valid_to) {
        this.msg('Please select valid to date', 0);
        return;
      }

      // Final sanity check before submitting
      var typeId = parseInt(this.lCompliance.compliance_type_id);
      if (isNaN(typeId) || typeId <= 0) {
        console.error('Invalid compliance_type_id after parsing:', typeId);
        this.msg('Invalid compliance type selected. Please try again.', 0);
        return;
      }

      this.beingSaved = true;

      var endpoint = action === 'Create' ? '/compliance/create' : '/compliance/update';

      var formatDateForMySQL = function formatDateForMySQL(dateStr) {
        if (!dateStr) return null;
        var d = new Date(dateStr);
        var month = (d.getMonth() + 1).toString().padStart(2, '0');
        var day = d.getDate().toString().padStart(2, '0');
        return d.getFullYear() + '-' + month + '-' + day;
      };

      var payload = {
        compliance_name: this.lCompliance.name,
        compliance_type_id: parseInt(this.lCompliance.compliance_type_id),
        category_id: parseInt(this.lCompliance.compliance_category_id),
        subcategory_id: parseInt(this.lCompliance.compliance_subcategory_id),
        community_id: parseInt(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.COMM_ID),
        status: 'Active',
        valid_from: formatDateForMySQL(this.lCompliance.valid_from),
        valid_to: formatDateForMySQL(this.lCompliance.valid_to),
        remarks: this.lCompliance.remarks || '',
        frequency: this.lCompliance.frequency,
        show_dashboard: this.lCompliance.show_dashboard ? 1 : 0,
        notify_before_days: this.lCompliance.notify_before_days || 0,
        created_by: parseInt(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID),
        updated_by: parseInt(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID)
      };

      if (action === 'Update') {
        payload.id = parseInt(this.lCompliance.id);
      }

      // Include files in payload
      if (this.lCompliance.files && this.lCompliance.files.length > 0) {
        payload.files = this.lCompliance.files.filter(function (f) {
          return f.is_selected;
        }).map(function (f) {
          return {
            file_url: f.file_url,
            file_name: f.file_name,
            is_selected: f.is_selected,
            is_changed: f.is_changed
          };
        });
      }

      this.axios.post(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + endpoint, payload).then(function (response) {
        if (action === 'Create') {
          _this8.msg('Compliance created successfully', 1);
        } else {
          _this8.msg('Compliance updated successfully', 1);
        }
        _this8.beingSaved = false;
        _this8.closeDialog();
      }).catch(function (err) {
        _this8.msg(err.response && err.response.data ? err.response.data : 'Error saving compliance', 0);
        _this8.beingSaved = false;
      });
    },
    deleteCompliance: function deleteCompliance(item) {
      var _this9 = this;

      if (!confirm('Are you sure you want to delete this compliance?')) {
        return;
      }

      this.beingSaved = true;

      if (!item.id) {
        this.msg('Invalid compliance selected', 0);
        this.beingSaved = false;
        return;
      }

      var payload = {
        id: item.id
      };

      this.axios.post(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + '/compliance/delete', payload).then(function (response) {
        _this9.msg('Compliance deleted successfully', 1);
        _this9.beingSaved = false;
        _this9.closeDialog();
      }).catch(function (err) {
        _this9.msg(err.response && err.response.data ? err.response.data : 'Error deleting compliance', 0);
        _this9.beingSaved = false;
      });
    }
  }
});

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(730)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Compliance.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(816);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(731)("ef23546a", content, true, {});

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800px"
    },
    model: {
      value: (_vm.showCompliance),
      callback: function($$v) {
        _vm.showCompliance = $$v
      },
      expression: "showCompliance"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "complianceForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveCompliance(_vm.lCompliance.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n                " + _vm._s(_vm.lCompliance.action) + " Compliance\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name *",
      "rules": [_vm.rules.required],
      "maxlength": "100"
    },
    model: {
      value: (_vm.lCompliance.name),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "name", $$v)
      },
      expression: "lCompliance.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.complianceTypeList,
      "item-text": "name",
      "item-value": "compliance_type_id",
      "label": "Compliance Type *",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lCompliance.compliance_type_id),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "compliance_type_id", $$v)
      },
      expression: "lCompliance.compliance_type_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.complianceCategoryList,
      "item-text": "name",
      "item-value": "id",
      "label": "Compliance Category *",
      "rules": [_vm.rules.required]
    },
    on: {
      "change": _vm.onComplianceCategoryChange
    },
    model: {
      value: (_vm.lCompliance.compliance_category_id),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "compliance_category_id", $$v)
      },
      expression: "lCompliance.compliance_category_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filteredComplianceSubcategories,
      "item-text": "name",
      "item-value": "id",
      "label": "Compliance Subcategory *",
      "rules": [_vm.rules.required],
      "disabled": !_vm.lCompliance.compliance_category_id
    },
    model: {
      value: (_vm.lCompliance.compliance_subcategory_id),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "compliance_subcategory_id", $$v)
      },
      expression: "lCompliance.compliance_subcategory_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Yearly', 'Half-yearly', 'Quarterly', 'Monthly', 'Onetime'],
      "label": "Frequency *",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lCompliance.frequency),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "frequency", $$v)
      },
      expression: "lCompliance.frequency"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Valid From (Start/Issue Date) *",
            "readonly": "",
            "rules": [_vm.rules.required]
          },
          model: {
            value: (_vm.lCompliance.valid_from),
            callback: function($$v) {
              _vm.$set(_vm.lCompliance, "valid_from", $$v)
            },
            expression: "lCompliance.valid_from"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.validFromMenu),
      callback: function($$v) {
        _vm.validFromMenu = $$v
      },
      expression: "validFromMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.validFromMenu = false
      }
    },
    model: {
      value: (_vm.lCompliance.valid_from),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "valid_from", $$v)
      },
      expression: "lCompliance.valid_from"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Valid To (Expiry Date) *",
            "readonly": "",
            "rules": [_vm.rules.required]
          },
          model: {
            value: (_vm.lCompliance.valid_to),
            callback: function($$v) {
              _vm.$set(_vm.lCompliance, "valid_to", $$v)
            },
            expression: "lCompliance.valid_to"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.validToMenu),
      callback: function($$v) {
        _vm.validToMenu = $$v
      },
      expression: "validToMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.lCompliance.valid_from
    },
    on: {
      "input": function($event) {
        _vm.validToMenu = false
      }
    },
    model: {
      value: (_vm.lCompliance.valid_to),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "valid_to", $$v)
      },
      expression: "lCompliance.valid_to"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Notify Before Days",
      "type": "number",
      "min": "0",
      "hint": "Number of days before expiry to send notification"
    },
    model: {
      value: (_vm.lCompliance.notify_before_days),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "notify_before_days", _vm._n($$v))
      },
      expression: "lCompliance.notify_before_days"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Remarks",
      "rows": "3",
      "hint": "Additional notes or comments"
    },
    model: {
      value: (_vm.lCompliance.remarks),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "remarks", $$v)
      },
      expression: "lCompliance.remarks"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Show on Dashboard",
      "color": "primary"
    },
    model: {
      value: (_vm.lCompliance.show_dashboard),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "show_dashboard", $$v)
      },
      expression: "lCompliance.show_dashboard"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0"
  }, [_vm._v("Attachments")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser()
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lCompliance.files && _vm.lCompliance.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lCompliance.files), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v("\n                          " + _vm._s(file.file_name) + "\n                          "), _vm._v(" "), (!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": _vm.config.FM_SPACES_BASE_URL + file.file_url,
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e()])], 1)
  }), 0) : _c('span', [_vm._v("\n                      Attachment if any"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(supports images, pdfs, docs and excels upto 20MB)")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lCompliance.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteCompliance(_vm.lCompliance)
      }
    }
  }, [_vm._v("\n                  Delete\n                ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("\n                  Save\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.d1e68cc0cd0403059720.js